import {object, field, number, string, Decoder} from 'json-bouncer'

export interface ProductShippingService {
    readonly id: number
    readonly shortName: string
    readonly longName: string
    readonly manufacturerId: number
}

export function productShippingServiceDecoder(): Decoder<ProductShippingService> {
    return object({
        id: field('productShippingServiceId', number()),
        shortName: field('shortName', string()),
        longName: field('longName', string()),
        manufacturerId: field('manufacturerId', number()),
    })
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Entities/ProductShippingService.ts